import type { Feature } from './feature'

/** Selectors for sibling users assigned to the current portal context. */
export class Selectors {
  /** Users available to the current user for sharing. */
  public readonly users
  /** Whether the current context user list is loading. */
  public readonly isLoading
  /** The error from the current context user-list request. */
  public readonly error

  constructor(feature: Feature) {
    const usersInfo = feature.state.project(state => state.users)

    this.users = usersInfo.project(info => info?.data)
    this.isLoading = usersInfo.project(info => info?.isLoading)
    this.error = usersInfo.project(info => info?.error)
  }
}
